import { render, staticRenderFns } from "./gl-form.vue?vue&type=template&id=562ceb1c"
import script from "./gl-form.vue?vue&type=script&lang=js"
export * from "./gl-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports